export default __webpack_public_path__ + "static/media/image-chat-icon.1d69a02e.svg";